var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"more-details",attrs:{"to":_vm.to}},[_c('span',{staticClass:"more-details__label"},[_vm._v(_vm._s(_vm.label))]),_c('svg',{attrs:{"width":"15","height":"15"}},[_c('path',{attrs:{"d":"M 7 1 L 1 1 L 1 14 L 14 14 L 14 8 M 14 6 L 14 1 L 9 1 M 14 1 L 5 10"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }